import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, dir } = useTranslation();

  useEffect(() => {
    // 404 error logged for monitoring
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6" dir={dir}>
      <div className="text-center space-y-6">
        <h1 className="text-6xl font-bold text-primary">404</h1>
        <p className="text-xl text-muted-foreground">Page not found</p>
        
        {/* Large accessible Back/Home button for gaze/switch users */}
        <Button
          size="lg"
          onClick={() => navigate("/")}
          className="h-16 px-8 text-lg rounded-2xl gap-3"
        >
          <Home className="w-6 h-6" />
          <span>{t("homePage")}</span>
          <ArrowRight className="w-6 h-6" />
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
